webpackJsonp([452],{

/***/ 1195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2149:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1195),
  /* template */
  __webpack_require__(2505),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/v2.0.0_zh-CN-282.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.0.0_zh-CN-282.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-164bca5c", Component.options)
  } else {
    hotAPI.reload("data-v-164bca5c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2505:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 更新到 vue@2.0，使用 "), _c('code', [_vm._v("v-model")]), _vm._v(" 而不是"), _c('code', [_vm._v(":show.sync")]), _vm._v("进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加属性 "), _c('code', [_vm._v("close-on-clicking-mask")]), _vm._v(", 适用于强制选择的场景")])]), _vm._v(" "), _c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 使用 "), _c('code', [_vm._v("v-model")]), _vm._v(" 而不是"), _c('code', [_vm._v(":show.sync")]), _vm._v("进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[todo] 修复动画")])]), _vm._v(" "), _c('h2', [_vm._v("Badge")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[todo] 在cell使用时，似乎不够居中")])]), _vm._v(" "), _c('h2', [_vm._v("ButtonTab")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 去除 Android 下点击可能出现的蓝色边框")])]), _vm._v(" "), _c('h2', [_vm._v("Checker")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持Object类型的值 #705")])]), _vm._v(" "), _c('h2', [_vm._v("Checklist")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 默认不显示错误，你可以监听on-error事件结合slot进行处理和显示")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加插槽 footer、after-title")]), _vm._v(" "), _c('li', [_vm._v("[change] 如果已经达到max上限，没有选中的选项将不能选择，因此不再和之前版本一样会出现最多可选max个的error信息")]), _vm._v(" "), _c('li', [_vm._v("[change] 默认 required 值为false, 与html规范一致")])]), _vm._v(" "), _c('h2', [_vm._v("ColorPicker")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[deprecated] 废弃，当前版本后不再继续维护")])]), _vm._v(" "), _c('h2', [_vm._v("Countdown")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[deprecated] 下一版本开始不再维护")])]), _vm._v(" "), _c('h2', [_vm._v("Countup")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 prop:"), _c('code', [_vm._v("start")]), _vm._v(", 现在你可以手动开始计数了")]), _vm._v(" "), _c('li', [_vm._v("[change] 更新依赖"), _c('code', [_vm._v("countup")]), _vm._v("为"), _c('code', [_vm._v("countup.js")])])]), _vm._v(" "), _c('h2', [_vm._v("FormPreview")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加"), _c('code', [_vm._v("form-preview")]), _vm._v("组件")])]), _vm._v(" "), _c('h2', [_vm._v("LoadMore")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加"), _c('code', [_vm._v("load-more")]), _vm._v("组件")])]), _vm._v(" "), _c('h2', [_vm._v("Popover")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[todo] 当切换i18n语言时，位置不正确")])]), _vm._v(" "), _c('h2', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 使用 "), _c('code', [_vm._v("v-model")]), _vm._v(" 而不是"), _c('code', [_vm._v(":show.sync")]), _vm._v("进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[change] 默认不显示遮罩")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加 isShowMask 属性")])]), _vm._v(" "), _c('h2', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 "), _c('code', [_vm._v("novalidate")]), _vm._v(" 及 "), _c('code', [_vm._v("iconType")]), _vm._v(" 可以禁用组件验证，手动显示 error 或者 success 样式")]), _vm._v(" "), _c('li', [_vm._v("[feature] "), _c('code', [_vm._v("is-type")]), _vm._v(" 支持传入函数")]), _vm._v(" "), _c('li', [_vm._v("[change] 受限于vue2不能动态设置type，目前"), _c('code', [_vm._v("type")]), _vm._v("支持 text password number email")])]), _vm._v(" "), _c('h2', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] fillable 值默认为false, 稍微保护一下不小心商城的后端接口没有做好数据校验的用户，导致用户粘贴负数还提交正确")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-164bca5c", module.exports)
  }
}

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2149);

/***/ })

});


// WEBPACK FOOTER //
// 452.1f9dc32b.js